export enum DebugKey {
  Frame = 'stars:frame',
  Request = 'stars:request',
  RequestInfo = 'stars:request:info',
  Socket = 'stars:socket',
  Wizard = 'stars:wizard',
  Embedded = 'stars:embedded',
  GeoComply = 'stars:geoComply',
  Error = 'stars:error',
  Bridge = 'stars:bridge',
  Monitor = 'stars:monitor',
  VaderArgs = 'vader:args',
  VaderServer = 'vader:server',
  VaderState = 'vader:state',
  VaderOneTrust = 'vader:one-trust',
  VaderCallback = 'vader:callback',
  VaderManifest = 'vader:manifest',
  VaderPage = 'vader:page',
  VaderPreview = 'vader:preview',
  VaderWebsite = 'vader:website',
  VaderWidget = 'vader:widget',
  SdkSocket = 'sdk:socket',
  SdkRequest = 'sdk:request',
  RgError = 'rgError:sePT',
  MockServer = 'mock:server'
}
